module.exports = __webpack_public_path__ + "img/remove-item-task.2f3ec101.svg";